import { render } from "./LocationsMaster.vue?vue&type=template&id=c53d5b9c"
import script from "./LocationsMaster.vue?vue&type=script&lang=js"
export * from "./LocationsMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__